import styled from 'styled-components';
import { lightGrey2Color } from 'js/config/style';

export default styled.img.attrs({
  src: '/images/chevron.svg',
})`
  color: ${lightGrey2Color};
  width: 0.75rem;
`;
